module.exports = __webpack_public_path__ + "static/img/icon_new_baby.2c5e5602.png";